import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function getLogin(sts) {
  const url = `${webservice}/getLogin?usuario=&claveAcceso=&origen=CARRITONUE&reabrirPedido=${sts}`;

  let response = {};

  await superagent
    .get(url)
    .timeout({
      response: 10000, // Wait 5 seconds for the server to start sending,
      deadline: 60000, // but allow 1 minute for the file to finish loading.
    })
    .set('Content-Type', 'application/json')
    .set('token', getCookie('TMBcartToken'))
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
